<template>
  <div class="w-full pr-3 pb-3" v-if="active">
    <slot v-if="false" name="title" />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ztTabItem',
  inheritAttrs: false,
  inject: {
    parentChildren: {
      from: 'children',
      default: () => () => [],
    },
    updateParentChildren: {
      from: 'updateChildren',
      default: () => () => {},
    },
    updateParentChildrenById: {
      from: 'updateChildrenById',
      default: () => () => {},
    },
  },
  props: {
    label: {
      default: 'Tab',
      type: String,
    },
    icon: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      active: false,
      id: null,
    }
  },
  watch: {
    label(val) {
      if (typeof this.updateParentChildrenById === 'function' && this.id !== null) {
        this.updateParentChildrenById(this.id, val)
      }
    },
  },
  mounted() {
    const childrenList = typeof this.parentChildren === 'function' ? this.parentChildren() : []
    this.id = childrenList.length
    const elem = {
      label: this.label,
      icon: this.icon,
      id: this.id,
      attrs: this.$attrs,
      title: this.$slots.title || null,
      updateActive: this.updateActive,
    }
    if (typeof this.updateParentChildren === 'function') {
      this.updateParentChildren(elem)
    }
  },
  methods: {
    updateActive(value) {
      this.active = value
    },
  },
}
</script>

<style lang="css" scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
